<template>
  <div
    class="row mt-5 pl-0 pr-0 pl-lg-3 pr-lg-3 pl-xl-5 pr-xl-5 pt-5 pb-5 font-details"
  >
    <div class="col-12">
      <div v-if="!loading.all" class="card card-details">
        <div class="card-body">
          <div class="row mb-3 mt-3 justify-content-center">
            <div class="col-12 col-md-9 col-lg-6 col-xl-5 col-sm-12">
              <div
                id="carousel-img"
                class="carousel slide size-carousel"
                data-ride="carousel"
              >
                <div class="carousel-inner sombra">
                  <div
                    v-for="data in listProduct" :key="data.id"
                    class="carousel-item"
                    :class="data.active"
                    data-interval="10000"
                  >
                    <img
                      style="padding:20px;"
                      :src="data.url"
                      class="img-carousel"
                      height="300"
                      width="300"
                      alt="..."
                    />
                  </div>
                </div>
                <a
                  class="carousel-control-prev"
                  @click="changeImg()"
                  href="#carousel-img"
                  role="button"
                  data-slide="prev"
                >
                  <span
                    class="carousel-control-prev-icon"
                    aria-hidden="true"
                  ></span>
                  <span class="sr-only">Previous</span>
                </a>
                <a
                  class="carousel-control-next"
                  @click="changeImg()"
                  href="#carousel-img"
                  role="button"
                  data-slide="next"
                >
                  <span
                    class="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                  <span class="sr-only">Next</span>
                </a>
              </div>
              <div
                v-if="section.mini"
                class="row p-1 mt-4 "
                style="background-color: #eaeaea;"
              >
                <div
                  v-for="(data, i) in listProduct" :key="data.id"
                  class="col-6 col-md-3 col-lg-3 col-xl-3 col-sm-12 p-1 "
                >
                  <div
                    style="cursor: pointer"
                    class="card card-d card-more"
                    :class="data.class"
                    data-target="#carousel-img"
                    :data-slide-to="i"
                  >
                    <img
                      :src="data.url"
                      class="mt-1 ml-1 img-c2"
                      height="90"
                      width="90"
                      alt="..."
                      @click="changeImg()"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-9 col-lg-6 col-xl-6 col-sm-12">
              <div class="c-title-details">
                <label class="title-details"
                  ><strong>{{ details.name }}</strong></label
                >
              </div>
              <div class="group-badge">

                <div v-if="details.type_catalogue == 1 || details.type_catalogue == null">
                  <h5 v-if="details.discount != null">
                    <span class="badge badge-danger">
                      <del>PUNTOS: {{ details.points }}</del>
                    </span><br>
                    <span class="badge badge-success">
                      {{ '-' + details.discount }}
                    </span>
                    <span class="badge badge-danger">
                      PUNTOS: {{ details.points_discount }}
                    </span>
                  </h5>
                  <h5 v-else>
                    <span class="badge badge-danger">
                      PUNTOS: {{ details.points }}
                    </span>
                  </h5>
                </div>

                <div v-if="details.type_catalogue == 2">
                  <h5 v-if="details.discount_lub != null">
                    <span class="badge badge-danger">
                      <del>PUNTOS: {{ details.points_lub }}</del>
                    </span><br>
                    <span class="badge badge-success">
                      {{ '-' + details.discount_lub }}
                    </span>
                    <span class="badge badge-danger">
                      PUNTOS: {{ details.points_discount_lub }}
                    </span>
                  </h5>
                  <h5 v-else>
                    <span class="badge badge-danger">
                      PUNTOS: {{ details.points_lub }}
                    </span>
                  </h5>
                </div>

                <div v-if="details.type_catalogue == 3 && details.points > 0 && (rol == 5 || flagMotero == 1)">
                  <h5 v-if="details.discount != null">
                    <span class="badge badge-danger">
                      <del>PUNTOS: {{ details.points }}</del>
                    </span><br>
                    <span class="badge badge-success">
                      {{ '-' + details.discount }}
                    </span>
                    <span class="badge badge-danger">
                      PUNTOS: {{ details.points_discount }}
                    </span>
                  </h5>
                  <h5 v-else>
                    <span class="badge badge-danger">
                      PUNTOS: {{ details.points }}
                    </span>
                  </h5>
                </div>

                <div v-if="details.type_catalogue == 3 && details.points_lub > 0 && (rol == 4 || flagLub == 1)">
                  <h5 v-if="details.discount_lub != null">
                    <span class="badge badge-danger">
                      <del>PUNTOS: {{ details.points_lub }}</del>
                    </span><br>
                    <span class="badge badge-success">
                      {{ '-' + details.discount_lub }}
                    </span>
                    <span class="badge badge-danger">
                      PUNTOS: {{ details.points_discount_lub }}
                    </span>
                  </h5>
                  <h5 v-else>
                    <span class="badge badge-danger">
                      PUNTOS: {{ details.points_lub }}
                    </span>
                  </h5>
                </div>

                <div v-if="details.type_catalogue == 4">
                  <h5 v-if="details.discount != null">
                    <span class="badge badge-danger">
                      <del>PUNTOS: {{ details.points }}</del>
                    </span><br>
                    <span class="badge badge-success">
                      {{ '-' + details.discount }}
                    </span>
                    <span class="badge badge-danger">
                      PUNTOS: {{ details.points_discount }}
                    </span>
                  </h5>
                  <h5 v-else>
                    <span class="badge badge-danger">
                      PUNTOS: {{ details.points }}
                    </span>
                  </h5>
                </div>

                <!-- <span
                  v-if="details.color != null"
                  class="badge badge-danger gotham-book"
                >
                  <label class="m-1">
                    &nbsp;COLOR: &nbsp;&nbsp;
                    <label
                      :style="{ backgroundColor: details.color }"
                      class="color"
                    ></label>
                    &nbsp;&nbsp;
                  </label>
                </span><br> -->
                <p class="description-d mt-3">
                  {{ details.description }}
                </p>

                <p
                  v-if="section.link"
                  class="description-link mt-3 pl-2 pl-md-2 pl-lg-3 pl-xl-3"
                  style="cursor: pointer"
                  @click="pdf()"
                >
                  <strong>Conoce las EDS Texaco en donde puedes redimir el bono.</strong>
                </p>
              </div>

              <v-row v-if="showTalla" class="mb-3 ml-0 ml-md-0 ml-xl-0 ml-lg-0">
                <v-col
                  class="pl-0 pl-xl-4 pl-lg-4 pl-md-0 pl-sm-4"
                  style="text-align: initial;"
                  cols="12"
                  sm="6"
                  md="12"
                  lg="6"
                  xl="6"
                >
                  <v-btn-toggle class="select-sizes" color="#dc3545">
                    <p class="text-danger pr-2" style="margin-bottom: 0px;">
                      <strong>Tallas:</strong>
                    </p>
                    <template v-for="(size, i) in details.product_size">
                      <v-btn v-if="(details.type_catalogue == 3 && size.type_size == 0 && (rol == 5 || flagMotero == 1)) || details.type_catalogue == 1 || details.type_catalogue == null" @click="changeSize(i)" small :key="i">
                        <strong>
                          <span>{{ size.sizes.name }}</span>
                        </strong>
                      </v-btn>
                      <v-btn v-else-if="(details.type_catalogue == 3 && size.type_size == 1 && (rol == 4 || flagLub == 1)) || details.type_catalogue == 2" @click="changeSize(i)" small :key="i">
                        <strong>
                          <span>{{ size.sizes.name }}</span>
                        </strong>
                      </v-btn>
                      <v-btn v-else-if="details.type_catalogue == 4 && size.type_size == 0 && rol == 2" @click="changeSize(i)" small :key="i">
                        <strong>
                          <span>{{ size.sizes.name }}</span>
                        </strong>
                      </v-btn>
                    </template>
                  </v-btn-toggle>
                  <p
                    id="msg-talla"
                    style="color:red;font-size: 12px;text-align: right;border-top-style: solid; display:none;"
                  >
                    <strong>seleccione talla</strong>
                  </p>
                </v-col>
                <v-col class="pl-0" cols="12" sm="6" md="12" lg="6" xl="6">
                  <v-card v-if="show.check" class="p-2" color="#000000c2">
                    <p class="title-dis-check" style="margin-bottom: 0px;">
                      TALLA DISPONIBLE
                    </p>
                    <p class="text-dis" style="margin-bottom: 0px;">
                      Actualmente la talla se encuentra disponible
                    </p>
                  </v-card>

                  <v-card v-if="show.not" class="p-2" color="#000000c2">
                    <p class="title-dis-not" style="margin-bottom: 0px;">
                      TALLA NO DISPONIBLE
                    </p>
                    <p class="text-dis" style="margin-bottom: 0px;">
                      Actualmente la talla se encuentra agotada intentalo en la
                      próxima promoción
                    </p>
                  </v-card>
                </v-col>
              </v-row>

              <div class="group-badge-count">
                <button
                  :disabled="loading.btn"
                  @click="addCard()"
                  type="button"
                  class="btn btn-danger btn-sm btn-redeem"
                  style="padding:1px 25px"
                >
                  <span
                    v-if="loading.btn"
                    class="spinner-border spinner-border-md"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <template v-else>
                    Redimir 
                  </template>
                </button>
              </div>
              <small v-if="errors.count" class="errors-message">{{
                errors.count
              }}</small>
            </div>
          </div>
          <div
            v-if="listOptions.length > 0"
            class="row mb-3 justify-content-center"
          >
            <div
              class="col-12 col-md-8 col-lg-4 col-xl-3 col-sm-12 pl-0 pl-lg-3"
            >
              <h2 class="mt-3 pt-3 text-i">
                <span
                  class="badge badge-danger gotham-book mr-lg-4 mr-xl-4 pt-2 text-i2"
                >
                  &nbsp;&nbsp; TE PUEDE INTERESAR &nbsp;&nbsp;</span
                >
              </h2>
            </div>
            <div class="col-12 col-md-9 col-lg-8 col-xl-7 col-sm-12 m-0 p-0">
              <div class="row m-1 justify-content-center">
                <div
                  v-for="data in listOptions" :key="data.id"
                  class="col-6 col-md-2 col-lg-2 col-xl-2 col-sm-12 p-1 font-details"
                >
                  <div class="card card-more m-0 p-0" style="cursor: pointer">
                    <img
                      :src="data.product.img"
                      @click="changeProduct(data)"
                      class="mt-1 ml-1 img-i"
                      style="cursor: pointer; text-align: center"
                      height="90"
                      width="90"
                      alt="..."
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="loading.all"
        class="spinner-border text-danger"
        style="width: 5rem; height: 5rem;"
        role="status"
      >
        <span class="visually-hidden"></span>
      </div>
      <ModalRegister></ModalRegister>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from 'axios'
import ModalRegister from "@/components/modalRegister";

export default {
  components: {
    ModalRegister: ModalRegister,
  },
  data() {
    return {
      show: {
        check: false,
        not: false,
      },
      form: {
        type_id: null,
      },
      sizeS: null,
      section: {
        mini: true,
        link: false,
      },
      loading: {
        all: false,
        btn: false,
      },
      details: {
        name: null,
        description: null,
        color: null,
        points: null,
      },
      listProduct: [],
      listOptions: [],
      numCant: 1,
      errors: {
        count: false,
      },
      requireTalla: true,
      rol: null,
      path: null,
      flagMotero: null,
      flagLub: null,
      flagRedimir: null,
      typeView: 0,
      showTalla: false,
    };
  },
  watch: {},
  methods: {
    changeSize(i) {
      if(this.showTalla){
        document.getElementById("msg-talla").style.display = "none";
      }
      this.sizeS = this.details.product_size[i].size_id;
      var data = {
        productId: this.details.product_size[i].product_id.toString(),
        sizeId: this.details.product_size[i].size_id.toString(),
        typeCatalogue: this.details.type_catalogue.toString(),
      };
      axios
        .post("api/size/availability", data)
        .then((res) => {
          if (res.data.cod == 0) {
            // console.log('res.data ', JSON.stringify(res.data));
            if(this.details.type_catalogue == 3){
              res.data.data.product.forEach(element => {
                if((element.type_size == 0 && element.availability > 0) || (element.type_size == 1 && element.availability > 0)){
                  this.show.check = true;
                  this.show.not = false;
                }
              });
            } else {
              if (res.data.data.motiveCod == 1) {
                this.show.not = true;
                this.show.check = false;
              } else if (res.data.data.motiveCod == 2) {
                this.show.check = true;
                this.show.not = false;
              } else {
                this.show.not = false;
                this.show.check = false;
              }
            }            
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pdf() {
      window.open(
        "https://lc.tars.dev/api/storage/03-06-2021/55232ec0-c468-11eb-8ace-19ea585543e9.pdf",
        "_blank"
      );
    },
    addCard(){
      // console.log(this.show.not);
      if (this.show.not) {
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "warning",
          title: "Oops...",
          text: "La talla seleccionada no esta disponible",
        });
        return false;
      }

      if (sessionStorage.getItem('token')) {
        console.log('El sessionStorage "token" está disponible.');
      } else {
        // Validar si el usuario esta logueado
        if(this.flagRedimir == 0){
          if(this.path == '/catalogo'){
            this.$swal({
              icon: 'info',
              title: 'Oops...',
              text: 'Debes iniciar sesión, o registrarte para poder agregar este producto a tu carro de compras',
              confirmButtonColor: '#dc3545',
              confirmButtonText: 'Iniciar sesión',
              showCancelButton: true,
              cancelButtonText: "Ir a registrarme",
              cancelButtonColor: "#dc3545",
            }).then((result) => {
              if (result.isConfirmed) {
                this.$router.push({ name: "login" });
              } else {
                this.$router.push({ name: "registerUser" });
              }
            });
          }
          else if(this.path == '/catalogo/lub'){
            this.$swal({
              icon: 'info',
              title: 'Oops...',
              text: 'Debes iniciar sesión, o registrarte para poder agregar este producto a tu carro de compras',
              confirmButtonColor: '#dc3545',
              confirmButtonText: 'Iniciar sesión',
              showCancelButton: true,
              cancelButtonText: "Ir a registrarme",
              cancelButtonColor: "#dc3545",
            }).then((result) => {
              if (result.isConfirmed) {
                this.$router.push({ name: "loginLubricator" });
              } else {
                $("#show_message_register").modal("show");
              }
            });
          }
          return false;
        }
      }

      var wonCategory = null;
      var won = false;
      if (
        this.details.product_type_id == 1 ||
        this.details.product_type_id == 2 ||
        this.details.product_type_id == 4 ||
        this.details.product_type_id == 6
      ) {
        wonCategory = 1;
        won = true;
      } else {
        wonCategory = 0;
        won = false;

        if(this.showTalla){
          if (this.sizeS == null && this.requireTalla) {
            document.getElementById("msg-talla").style.display = "block";
          }
        }
        if (!this.requireTalla) {
          this.sizeS = this.details.product_size[0].size_id;
        }
      }

      var data = {
        productId: this.details.id,
        quantity: this.numCant,
        wonCategory: wonCategory,
        won: won,
        sizeId: this.sizeS,
        typeCatalogue: this.details.type_catalogue,
        typeView: this.typeView
      };

      var data1 = {
        quantity: this.numCant,
        item: this.details,
      };
      this.loading.btn = true;
      // console.log(data);
      axios
        .post("superAdmin/commerce/shoppingCart", data)
        .then((res) => {
          if (res.data.cod == 0) {
            var app = this;
            this.$store.commit("addCard", data1);
            $("#exampleModal").modal("hide");
            this.$swal({
              title: "Agregado exitosamente al carrito de compras",
              text: "Gracias por participar.",
              icon: "success",
              showCancelButton: true,
              cancelButtonText: "Seguir comprando",
              cancelButtonColor: "#1da5df",
              confirmButtonText: "Carrito de compras",
              confirmButtonColor: "#dc3545",
            }).then((result) => {
              if (result.isConfirmed) {
                app.irCarrito();
              } 
              else if (result.isDismissed) {
                window.history.back();
              }
            });
          } else {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "warning",
              title: "Oops...",
              text: res.data.message,
            });
          }
          this.loading.btn = false;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            $("#exampleModal").modal("hide");
            this.$router.push({
              name: "login2",
              params: { option: "digitales" },
            });
          } else if (
            error.response.data.cod == 500 ||
            error.response.data.cod == 400
          ) {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          } else {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          }
          this.loading.btn = false;
        });
    },
    minusCount() {
      if (this.numCant > 1) {
        this.errors.count = false;
        this.numCant--;
      } else {
        this.errors.count = "La cantidad del producto no puede ser menor a 1";
      }
    },
    addCount() {
      if (this.numCant < 99) {
        this.errors.count = false;
        this.numCant++;
      } else {
        this.errors.count = "La cantidad no puede ser mayor a 99";
      }
    },
    changeProduct(data) {
      this.getProductoDetails(data.product_related_id, 2);
      this.$router.push({
        name: "catalogueDetailsM",
        params: { id: data.product_related_id },
      });
    },
    changeImg() {
      var app = this;
      var from = null;
      var to = null;
      $("#carousel-img").on("slid.bs.carousel", function(e) {
        from = e.from;
        to = e.to;
        app.listProduct[to].class = "card-details-r";
        app.listProduct[from].class = "";
      });
    },
    getProductoDetails(id, origin) {
      var data = null;
      if (origin == 1) {
        data = this.$route.params.id;
        localStorage.setItem('productId', data);

        this.path = this.$route.params.ruta;
        if(this.path == '/catalogo'){
          this.flagMotero = 1;
        }
        else if(this.path == '/catalogo/lub'){
          this.flagLub = 1;
        }
      } else {
        data = id;
      }
      this.loading.all = true;
      axios
        .get("api/product/get/detail",{
          params: {
            productId: data
          }
        })
        .then((res) => {
          if (res.data.data[0].product_size >= 1) {
            if (res.data.data[0].product_size[0].sizes.name == "No aplica") {
              this.requireTalla = false;
            }
          }
          /* if (res.data[0].product_size.length == 0) {
            this.requireTalla = false;
          } */

          this.changeImg();
          this.loading.all = false;
          if (res.data.cod == 0) {
            this.details = res.data.data[0];
            this.listOptions = res.data.data[0].relation;
            this.listProduct = [];

            for (let i = 0; i < this.details.product_size.length; i++) {
              this.details.product_size[i].active = "";
            }

            if (
              res.data.data[0].product_type_id == 1 ||
              res.data.data[0].product_type_id == 2 ||
              res.data.data[0].product_type_id == 4
            ) {
              this.section.mini = false;
            } else {
              this.section.mini = true;
            }
            if (res.data.data[0].product_type_id == 5) {
              this.changeSize(0);
              this.section.link = false;
            } else {
              this.section.link = false;
              this.showTalla = true;
            }
            if (res.data.data[0].file.length == 0) {
              this.listProduct.push({
                url: res.data.data[0].img,
                id: res.data.data[0].id,
                class: "card-details-r",
                active: "active",
              });
            } else {
              for (let i = 0; i < res.data.data[0].file.length; i++) {
                this.listProduct.push({
                  url: res.data.data[0].file[i].url,
                  id: res.data.data[0].id,
                  class: "",
                  active: "",
                });
              }
              this.listProduct[0].class = "card-details-r";
              this.listProduct[0].active = "active";
            }
          }
        })
        .catch((error) => {
          this.loading.all = false;
          console.log(error);
        });
    },
    irCarrito() {
      this.$router.push({ name: "userCard" });
    },
    getUserSesion(){
      var app = this;
      app.flagUser = localStorage.getItem('flagUser');
      // console.log('app.flagUser: ', app.flagUser);
      axios.get("api/showUser").then(function(res) {
        if(res.data.ResponseCode == 0){
          app.user = res.data.User;
          app.rol = app.user.role_id;
          // console.log('app.rol: ', app.rol);
        }
      })
      .catch(function(error) {
        console.log('error: ', error);
      });
    },
  },
  async mounted() {
    this.getUserSesion();
    await this.getProductoDetails(null, 1);
    this.flagRedimir = localStorage.getItem('flagRedimir');
    if(this.path == '/app/user/catalogo'){
      this.typeView = 1;
    } else if(this.path == '/app/user/catalogo/lub'){
      this.typeView = 2;
    }
  },
};
</script>

<style scoped>
.select-sizes{
  justify-content: center;
  align-items: center;
  grid-gap: 5px;
  /* grid-template-columns: repeat(4, auto); */
}
.select-sizes .v-btn--active {
  background-color: #dc3545 !important;
  color: #fff !important;
}
.v-btn:not(.v-btn--round).v-size--small {
  height: 28px;
  min-width: auto;
  padding: 0 8px;
}
.title-dis-not {
  margin-bottom: 0px;
  background-color: #dc3545;
  color: white;
  font-size: 10px;
  font-weight: bold;
}
.title-dis-check {
  margin-bottom: 0px;
  background-color: #31ae37;
  color: white;
  font-size: 10px;
  font-weight: bold;
}
.text-dis {
  font-size: 10px;
  color: white;
}
.select-sizes .select-sizes {
  min-width: 35px !important;
}
.t-sizes-d {
  border-collapse: separate !important;
  border-spacing: 5px;
  padding: 2px 8px;
  background-color: #eaeaea;
  border-radius: 5px;
}
.c-sizes {
  border: 1px solid;
  padding: 1px 5px 1px 5px;
  border-color: #b4b2b2;
  color: #000;
  font-weight: bold;
  font-style: italic;
  cursor: pointer;
}
.btn-group-active:active {
  background-color: #dc3545 !important;
  color: #fff !important;
}
.c-sizes-active {
  background-color: #dc3545;
  color: #fff;
}

/* Tarjeta principal */
.card-details {
  border-radius: 25px;
}

/* fondo */
.font-details {
  background-color: #eaeaea;
}

/* Carrusel */
.size-carousel {
  height: 300px;
  width: 300px;
  margin-left: 15%;
}
.sombra {
  border-radius: 8px;
  box-shadow: 5px 5px 10px 0 rgba(0, 0, 0, 0.15);
}
.carousel-control-next-icon {
  position: absolute;
  left: 30px;
  width: 40px;
  height: 40px;
  background-image: url("./../../../assets/icon/next.png");
}
.carousel-control-prev-icon {
  position: absolute;
  right: 30px;
  width: 40px;
  height: 40px;
  background-image: url("./../../../assets/icon/prev.png");
}

/* Tarjetas pequeñas de visual del producto */
.card-d {
  height: 100px;
  width: 100px;
  border-radius: 9px;
}

/* Tarjetas pequeñas de visual del producto active */
.card-details-r {
  border: 2px solid;
  border-color: #dc3545;
}

/* Tarjetas mas productos */
.card-more:hover {
  filter: opacity(0.5);
}

/* contenido del porducto */
.c-title-details {
  text-align: initial;
  padding: 30px 0px 0px 20px;
}
.title-details {
  background-color: black;
  color: #dc3545;
  font-size: 18px;
  border-radius: 5px;
  padding: 5px 10px 4px 12px;
  font-family: "GothamBoldItalic", sans-serif;
}
.description-link {
  color: #d82233;
  background-color: #fdcd00;
}
.gotham-book {
  font-family: "GothamBookItalic", sans-serif;
}

/* Tarjetas de puntos, color, cantidad */
.group-badge {
  padding: 15px 0px 0px 50px;
  text-align: initial;
}
.group-badge-count {
  padding: 0px 0px 0px 50px;
  text-align: initial;
}
.badge-count {
  background-color: #eaeaea;
  color: black;
  font-family: "GothamBoldItalic", sans-serif;
}
.btn-redeem {
  padding-bottom: 1px;
  padding-top: 2px;
  font-family: "GothamBoldItalic", sans-serif;
}
.errors-message {
  padding: 5px 0px 0px 50px;
  float: left;
  color: #dc3545;
}
.badge-success{
  font-size: 20px;
  margin: 2px 1px;
}

/* Descripción */
.description-d {
  text-align: left;
  color: #989494;
  font-family: "GothamBoldItalic", sans-serif;
}
.color {
  margin: -3px;
  width: 15px;
  height: 15px;
  border: 1px solid;
}

/* Titulo me kbteresa */
.text-i {
  text-align: end;
}
.text-i2 {
  font-size: 18px;
}

/* QUERIES */

/* LAPTOP NORMAL */
@media (max-width: 1200px) {
  .text-i {
    text-align: initial;
  }
  .c-title-details {
    padding: 30px 0px 0px 0px;
  }
  .group-badge {
    padding: 15px 0px 0px 0px;
  }
  .group-badge-count {
    padding: 0px 0px 0px 0px;
  }
  .description-d {
    font-size: 15px;
  }
  .card-d {
    height: 100px;
    width: 100px;
    border-radius: 9px;
  }
  .img-i {
    width: 90%;
    height: 90%;
  }
  .img-c2 {
    width: 90%;
    height: 90%;
  }
}

/* TABLET */
@media (max-width: 1023px) {
  .text-i {
    text-align: initial;
  }
  .c-title-details {
    padding: 30px 0px 0px 0px;
  }
  .group-badge {
    padding: 15px 0px 0px 0px;
  }
  .group-badge-count {
    padding: 0px 0px 0px 0px;
  }
  .description-d {
    font-size: 15px;
  }
  .card-d {
    height: 110px;
    width: 110px;
    border-radius: 9px;
  }
  .img-i {
    width: 90%;
    height: 90%;
  }
  .img-c2 {
    width: 90%;
    height: 90%;
  }
}

/* MOBILE L*/
@media (max-width: 767px) {
  .text-i2 {
    font-size: 15px;
    margin-left: 2%;
  }
  
  /* Carrusel */
  .size-carousel {
    height: 310px;
    width: 310px;
    margin-left: 3%;
  }
  .img-carousel {
    height: 100%;
    width: 100%;
  }
  .carousel-control-next-icon {
    position: absolute;
    left: 25px;
    width: 30px;
    height: 30px;
    background-image: url("./../../../assets/icon/next.png");
  }
  .carousel-control-prev-icon {
    position: absolute;
    right: 20px;
    width: 30px;
    height: 30px;
    background-image: url("./../../../assets/icon/prev.png");
  }
  .img-c2 {
    width: 130px;
    height: 130px;
  }
  .card-d {
    height: 140px;
    width: 140px;
    border-radius: 9px;
  }
  .text-i {
    text-align: initial;
  }
  .c-title-details {
    padding: 30px 0px 0px 0px;
  }
  .title-details {
    font-size: 15px;
  }
  .group-badge {
    padding: 15px 0px 0px 0px;
  }
  .group-badge-count {
    padding: 0px 0px 0px 0px;
  }
  .description-d {
    font-size: 15px;
  }
  .img-i {
    width: 90%;
    height: 90%;
  }
}

/* MOBILE M */
@media (max-width: 375px) {
  /* Carrusel */
  .size-carousel {
    height: 310px;
    width: 310px;
    margin-left: -8%;
  }
  .img-carousel {
    height: 100%;
    width: 100%;
  }
  .img-c2 {
    width: 110px;
    height: 110px;
  }
  .card-d {
    height: 120px;
    width: 120px;
    border-radius: 9px;
  }
  .img-i {
    width: 90%;
    height: 90%;
  }
}

/* MOBILE S */
@media (max-width: 320px) {
  /* Carrusel */
  .size-carousel {
    height: 250px;
    width: 250px;
    margin-left: -8%;
  }
  .img-carousel {
    height: 100%;
    width: 100%;
  }
  .img-i {
    width: 100px;
    height: 100px;
  }
  .img-c2 {
    width: 90px;
    height: 90px;
  }
  .card-d {
    height: 100px;
    width: 100px;
    border-radius: 9px;
  }
}

/* Nuevas fuentes */
@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}
</style>
